var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11744_51068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2526 6.66634H15.1693V4.99967C15.1693 4.08301 14.4193 3.33301 13.5026 3.33301H3.5026C2.58594 3.33301 1.83594 4.08301 1.83594 4.99967V12.4997C1.83594 13.4163 2.58594 14.1663 3.5026 14.1663C3.5026 15.5497 4.61927 16.6663 6.0026 16.6663C7.38594 16.6663 8.5026 15.5497 8.5026 14.1663H13.5026C13.5026 15.5497 14.6193 16.6663 16.0026 16.6663C17.3859 16.6663 18.5026 15.5497 18.5026 14.1663H19.3359C19.7943 14.1663 20.1693 13.7913 20.1693 13.333V10.558C20.1693 10.1997 20.0526 9.84967 19.8359 9.55801L17.9193 6.99967C17.7609 6.79134 17.5109 6.66634 17.2526 6.66634ZM6.0026 14.9997C5.54427 14.9997 5.16927 14.6247 5.16927 14.1663C5.16927 13.708 5.54427 13.333 6.0026 13.333C6.46094 13.333 6.83594 13.708 6.83594 14.1663C6.83594 14.6247 6.46094 14.9997 6.0026 14.9997ZM17.2526 7.91634L18.8859 9.99967H15.1693V7.91634H17.2526ZM16.0026 14.9997C15.5443 14.9997 15.1693 14.6247 15.1693 14.1663C15.1693 13.708 15.5443 13.333 16.0026 13.333C16.4609 13.333 16.8359 13.708 16.8359 14.1663C16.8359 14.6247 16.4609 14.9997 16.0026 14.9997Z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 9,
    height: 3,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 9,
    height: 3,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 8,
    height: 1,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 8,
    height: 1,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 2,
    height: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11744_51068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnDelivery);
export default __webpack_public_path__ + "static/media/onDelivery.cbefd6382b590388dc31e1d9043f212a.svg";
export { ForwardRef as ReactComponent };